import { Button, Group, Stack, TextInput } from "@mantine/core";
import { TEmbaixadorPessoaForm } from "../../firestore";
import useEmbaixadorPessoaForm from "../../hooks/useEmbaixadorPessoaForm";

interface EmbaixadorPessoaFormProperties {
  embaixadorPessoa: TEmbaixadorPessoaForm & Partial<Pick<TEmbaixadorPessoa, "id">>;
  readOnly?: boolean;
}

const EmbaixadorPessoaForm = ({ embaixadorPessoa, readOnly = false }: EmbaixadorPessoaFormProperties) => {
  const { form, isPending, onSubmit } = useEmbaixadorPessoaForm(embaixadorPessoa);

  if (readOnly) {
    return (
      <Stack>
        <TextInput label="Nome" value={embaixadorPessoa.nome} readOnly />
        <TextInput label="Telefone" value={embaixadorPessoa.telefone || ""} readOnly />
        <TextInput label="Email" value={embaixadorPessoa.email || ""} readOnly />
      </Stack>
    );
  }

  return (
    <form onSubmit={onSubmit}>
      <Stack>
        <TextInput label="Nome" placeholder="Digite o nome completo" withAsterisk {...form.getInputProps("nome")} />

        <TextInput label="Telefone" placeholder="(11) 99999-9999" {...form.getInputProps("telefone")} />

        <TextInput label="Email" placeholder="exemplo@email.com" {...form.getInputProps("email")} />

        <Group justify="flex-end" mt="md">
          <Button type="submit" loading={isPending} disabled={isPending}>
            {embaixadorPessoa.id ? "Atualizar" : "Cadastrar"}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};

export default EmbaixadorPessoaForm;
